import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { resetPassword } from "@/lib/site";

export default function NulstilPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await resetPassword({ token, password });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Linket er udløbet eller ugyldigt.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-6 pb-24 pt-36">
      <div className="w-full max-w-md border border-white/10 bg-moss p-8">
        <div className="mb-8 flex items-center gap-3">
          <KeyRound className="h-5 w-5 text-forest" />
          <h1 className="font-serif text-3xl tracking-tight text-cream">Ny adgangskode</h1>
        </div>
        {done ? (
          <>
            <p data-testid="reset-success" className="text-sm leading-relaxed text-sage">
              Din adgangskode er opdateret. Du kan nu logge ind med den nye adgangskode.
            </p>
            <Link
              data-testid="reset-login-link"
              to="/min-konto"
              className="mt-8 inline-block rounded-full bg-forest px-7 py-3 font-mono text-xs uppercase tracking-[0.2em] text-cream transition-colors hover:bg-pale hover:text-ink"
            >
              Log ind
            </Link>
          </>
        ) : (
          <form data-testid="reset-form" onSubmit={submit} className="space-y-5">
            <input
              data-testid="reset-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ny adgangskode (min. 6 tegn)"
              className="w-full border border-white/15 bg-ink px-4 py-3 text-sm text-cream placeholder:text-sage/50 outline-none transition-colors duration-300 focus:border-forest"
            />
            <button
              data-testid="reset-submit-button"
              type="submit"
              disabled={busy || !token}
              className="flex w-full items-center justify-center gap-3 rounded-full bg-forest py-4 font-mono text-xs uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:bg-pale hover:text-ink disabled:opacity-60"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Gem ny adgangskode"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
